// CustomerSelectionModal.js
import React, { useState, useEffect, useContext, useRef } from 'react';
import 'datatables.net-bs5';
import $ from 'jquery';
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import Draggable from 'react-draggable';
function CustomerSelectionModal({ show, onClose, LeadList, onSelectLead }) {
    const { theme, toggleTheme } = useContext(ThemeContext);
    let accordTheme = "accordion-header-light";
    if (theme == "dark") {
        accordTheme = "accordion-header-dark";
    }
    const tableRef = useRef();
    const initDataTable = () => {
        if ($.fn.DataTable.isDataTable(tableRef.current)) {
            console.log('Destroying existing DataTable instance...');
            $(tableRef.current).DataTable().destroy();
        }
        $(tableRef.current).DataTable({
            dom: '<"row"<"col-sm-6 d-flex align-items-center"Bf><"col-sm-6 d-flex justify-content-end"p>>rt',
            pagingType: 'full_numbers',
            language: {
                search: "_INPUT_",
                searchPlaceholder: "Search..."
            },

            lengthChange: false,
            initComplete: function () {
                console.log('DataTable initialization complete.');
                $('.btn-dataTable').css('background', 'none');
                $('.btn-dataTable').css('border', 'none');
                $('.btn-dataTable').removeClass('btn-secondary');
                $('.btn-dataTable').removeClass('btn');
                $('.btn-dataTable').removeClass('btn-dataTable');
                //  $('.dt-search input[type="search"]').css('margin-left', '10px');
                //  $('.dt-search input[type="search"]').css('height', '25px');
            }
        });

        $('#datatable-search-container').append($('.dataTables_filter').html());
        $('.dataTables_filter').remove();
    };

    useEffect(() => {
        if (LeadList && LeadList.length > 0) {            
            initDataTable();
        }
    }, [LeadList]);
    const truncateText = (text, maxLength = 15) => {
        if (!text) return '';
        return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
    };
    const handleStart = (e, ui) => {
        e.stopPropagation();
    }
    return (
        <div className={`modal fade ${show ? 'show' : ''}`} style={{ display: show ? 'block' : 'none' }} tabIndex="-1">
            <div className="modal-dialog modal-lg">
                <Draggable handle=".modal-content" onStart={handleStart}
                    cancel="input, textarea, select, button, ul,li,table,a,ReactQuill,p">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Select Lead</h5>
                            <button type="button" className="btn-close" onClick={onClose}></button>
                        </div>
                        <div className="modal-body">
                            <div style={{ "marginLeft": "10px", "marginRight": "0px", "marginTop": "10px" }}>
                                <table className="table table-striped" ref={tableRef} style={{ "width": "100%" }}>
                                    <thead>
                                        <tr>
                                            <th className="no-wrap">Company Name</th>
                                            <th className="no-wrap">Topic</th>
                                            <th className="no-wrap">Weight</th>
                                            <th className="no-wrap">County</th>
                                            <th className="no-wrap">Contact Name</th>
                                            <th className="no-wrap">Telephone</th>
                                            <th className="no-wrap">Mobile</th>
                                            <th className="no-wrap">Email</th>
                                            <th className="no-wrap">Status</th>
                                            <th className="no-wrap">Source</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {LeadList.map(lead => (
                                            <tr key={lead.ID} onClick={() => onSelectLead(lead)} style={{ cursor: 'pointer' }}>
                                                <td className="no-wrap">{lead.vc_Company}</td>
                                                    <td className="no-wrap">
                                                        {lead.vc_Topic && lead.vc_Topic.length > 12
                                                            ? `${lead.vc_Topic.substring(0, 12)}...`
                                                            : lead.vc_Topic}
                                                    </td>
                                                    <td className="no-wrap">

                                                        {lead.dec_Weight && lead.dec_Weight.length > 12
                                                            ? `${lead.dec_Weight.substring(0, 12)}...`
                                                            : lead.dec_Weight}
                                                    </td>
                                                    <td className="no-wrap">
                                                        {lead.vc_County && lead.vc_County.length > 12
                                                            ? `${lead.vc_County.substring(0, 12)}...`
                                                            : lead.vc_County}
                                                    </td>

                                                    <td className="no-wrap">{lead.vc_Title} {lead.vc_FirstName} {lead.vc_Surname}</td>
                                                    <td className="no-wrap">{lead.vc_Phone} </td>
                                                    <td className="no-wrap">{lead.vc_Mobile} </td>
                                                    <td className="no-wrap">{lead.vc_Email} </td>
                                                    <td className="no-wrap">{lead.SourceName} </td>
                                                    <td className="no-wrap">{lead.StatusName} </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>

                    </div>
                </Draggable>
            </div>
        </div>
    );
}

export default CustomerSelectionModal;
